import RectangleGroupIcon from "@heroicons/react/24/outline/RectangleGroupIcon";
import PlayCircleIcon from "@heroicons/react/24/solid/PlayCircleIcon";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled as styling } from "@mui/material/styles";
import ReactPlayer from "react-player";
import withCompanyVideoFallback from "../../../../helpers/withCompanyVideoFallback";
import Color from "../../../../assets/colors";

export const GridStyled = styling(Grid)((props) => ({
  //
}));

export const ImageStyled = styling("img")({
  objectFit: "cover",
  width: "100%",
  borderRadius: "10px",
  height: "100%",
  cursor: "pointer",

  "@media (max-width: 640px)": {
    minWidth: "300px",
  },
});

export const ReactPlayerStyled = styling(withCompanyVideoFallback(ReactPlayer))((props) => ({
  minWidth: "100%",
  minHeight: "100%",
  objectFit: "cover",
  overflow: "hidden",
}));

export const PlayIconStyled = styling(PlayCircleIcon)((props) => ({
  strokeWidth: "0.5px",
  stroke: "rgba(0, 0, 0, 0.38)",
  color: Color.white,
  width: "50px",
  height: "50px",
}));

export const ShowAllMediaButton = styling(Button)({
  fontWeight: "400",
  padding: "5px 7px",
  border: `1px solid ${Color.black}`,
  gap: "12px",
  textTransform: "capitalize",
  position: "absolute",
  right: "10px",
  bottom: "10px",
  backgroundColor: Color.white,
  color: "rgba(0, 0, 0, 0.87)",

  transition: "all 0.075s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      backgroundColor: Color.white,
      border: `1px solid ${Color.black}`,
      boxShadow: "2px 2px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-2px, -2px)",
      cursor: "pointer",
    },
  },
});

export const ShowAllMediaIcon = styling(RectangleGroupIcon)((props) => ({
  height: "24px",
  width: "24px",
}));

export const OutlinedButton = styling(Button)({
  gap: "0.65rem",
  textTransform: "capitalize",
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "16px",
  fontWeight: "400",
  padding: "15px 30px",
  borderRadius: "8px",

  backgroundColor: Color.white,
  border: `1.5px solid ${Color.black}`,

  "@media (min-width: 1280px)": {
    "&:hover": {
      backgroundColor: Color.white,
      boxShadow: "0px 4px 0px 0px rgba(0,0,0,1)",
      border: `1.5px solid ${Color.black}`,
    },
  },

  "@media (max-width: 640px)": {
    width: "100%",
  },
});
